<script setup lang="ts">
import WorkerLogin from '@/components/auth/WorkerLogin.vue'
import AppDrawer from '@/components/layout/AppDrawer.vue'
import AppFrame from '@/components/layout/AppFrame.vue'
import { useWorkerAuth } from '@/composables/useWorkerAuth'

const { isAuthenticated } = useWorkerAuth()
</script>

<template>
  <WorkerLogin v-if="!isAuthenticated" />
  <AppFrame v-else>
    <RouterView />
    <AppDrawer />
  </AppFrame>
</template>
